import React, { useState, useCallback } from "react";
import { Route, Navigate, Routes, useLocation } from 'react-router-dom';

import Home from "./components/Home";

import { MetaMaskContext } from './context/mm-context';

const abi_TribesOfTheAftermath = require('./contracts/TribesOfTheAftermath_ABI.json');

import './colours.css';

function App() {

  const [isConnected, setIsConnected] = useState(false);
  const [ethContract, setEthContract] = useState(null);
  const [ethAddress, setEthAddress] = useState(null);
  const [ensAddress, setEnsAddress] = useState(null);

  const abi = abi_TribesOfTheAftermath;
  const contractAddress = "0x506efDfCAc212330510663a1C6ac7BE21A18fC08";
  const network = {
    networkId: 1,
    networkName: "Ethereum Mainnet",
    etherScan: `https://etherscan.io/`,
    openSea: `https://opensea.io/`
  };

  const authenticate = useCallback(() => {
    setIsConnected(true);
  }, []);

  const disconnect = useCallback(() => {
    setIsConnected(false);
    setEthContract(false);
  }, []);

  const contract = useCallback((c) => {
    setEthContract(c);
  }, []);

  const address = useCallback((a) => {
    setEthAddress(a);
  }, []);

  const ens = useCallback((a) => {
    setEnsAddress(a);
  }, []);


  return (
    
      <MetaMaskContext.Provider value={{
        isConnected: isConnected,
        authenticate: authenticate,
        disconnect: disconnect,
        ethContract: ethContract,
        contract: contract,
        ethAddress: ethAddress,
        address: address,
        ensAddress: ensAddress,
        ens: ens,
        abi,
        contractAddress,
        network
      }}>
        <>
            <Routes>
              <Route path="/" exact element={<Home />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </>
      </MetaMaskContext.Provider >
  );
}

export default App;
